    import React, { Component } from "react";
    import ContentWrapper from "../../../components/common/ContentWrapper.js";
    import Card from "../../../components/common/Card.js";
    import CardHeader from "../../../components/common/CardHeader.js";
    import CardBody from "../../../components/common/CardBody.js";
    import Form from "react-bootstrap/Form";
    import Button from "react-bootstrap/Button";
    import { StudentAddressTypeService } from "../../../service/settings/manage/student_address_type.service.js";
    import { StudentAddressService } from "../../../service/manage/registration/student_address.service.js";
    import {NonAcademicService} from "../../../service/manage/registration/reg_b_staff.service.js"
    import { ProvinceService } from "../../../service/settings/manage/province.service.js";
    import { CityService } from "../../../service/settings/manage/city.service.js";
    import { GenderService } from "../../../service/settings/manage/gender.service.js";
    import Spinner from "react-bootstrap/Spinner";
    import SummarizeIcon from '@mui/icons-material/Summarize';
    import {
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    } from "@mui/material";
    import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
    import debounce from "lodash.debounce";
    import sweetAlert, {
    sweetConfirmAlert,
    sweetStatusAlert,
    } from "../../../components/common/SweetAlert.js";
    import { StudentService } from "../../../service/manage/registration/reg_b.service.js";
    import { UserManagementService } from "../../../service/user_management/user_management.service.js";
    import SimpleReactValidator from "simple-react-validator";
    import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
    import { customerConstants } from "../../../helper/constants.js";
    import config from "../../../helper/config.js";
    import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
    import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
    import StudentsStatModel from "../dashboard/StudentStatModel.js";
    import RegBAddStaffModal from "../dashboard/registration_b/components/RegBAddStaffModal.js";
    import RegBUpdateStaffModal from "../dashboard/registration_b/components/RegBUpdateStaffModal.js";
    import RegBStaffDocUpdateModal from "../dashboard/registration_b/components/RegBStaffDocUpdateModal.js";
    import { routes } from "../../../helper/routes.js";

    const getCustomerFeatureFlag = () => {
    return config.customerConfigs.featureFlag;
    };

    const customer = getCustomerFeatureFlag();
    let isEdfoci, addBtnStyle, closeBtnStyle;
    switch (customer) {
    case customerConstants.EXO_CUSTOMER1:
        isEdfoci = false;
        break;
    case customerConstants.EXO_CUSTOMER2:
        isEdfoci = false;
        closeBtnStyle = {
        color: "var(--maincolor-cmc)",
        backgroundColor: "#E5F5FF",
        borderColor: "transparent",
        };
        addBtnStyle = {
        color: "#fff",
        backgroundColor: "var(--maincolor-cmc)",
        borderColor: "transparent",
        };
        break;
    default:
        isEdfoci = true;
        break;
    }

    export default class ManageNonAcademic extends Component {
    constructor(props) {
        super(props);
        this.state = {
        showModal: false,
        students: [],
        first_name: "",
        last_name: "",
        nic: "",
        dob: "",
        email: "",
        phone_number: "",
        gender_id: "",
        status_id: "",
        qrmodal: false,
        created_on: "",
        created_by: "",
        genders: [],
        titles: [],
        countries: [],
        stu_statuses: [],
        statusTypes: [],
        StuStatustype: "Availability",
        showInsertModal: false,
        studentAddressTypes: [],
        studentAddresses: [],
        isLoading: false,
        isTableDataLoading: true,
        limit: 10, // Set the desired limit
        offset: 0, // Set the desired offset
        search_term: "",
        totalStudents: 10,
        currentPage: 0,
        isModified: false,
        isAddressesLoading: false,
        editVisibility: false,
        addVisibility: false,
        deleteVisibility: false,
        sortColumn: "user_code",
        sortDirection: "asc",
        errorProvince: [],
        errorCity: [],
        addressValidity: [],
        hidden: false,
        studentAddressesAdd: [],
        node_mid: null,
        user_list_table_id: null,
        session_staff_user_id: null,
        grade: null,
        school: "",
        main_table_id: null,
        breadcrumb2: null,
        nodeTitle: null,
        user_code: "",
        grades: [],
        selectedStudent: [],
        isAddStudentModalOpen: false,
        isAddStaffModalOpen: false,
        isUpdateStudentModalOpen: false,
        isUpdateStaffModalOpen: false,
        is_lg_user: false,
        studentStatsModal: false,
        selectedStudentStat: null,
        updateStudentItem: null,
        olQualifications: [],
        alQualifications: [],
        otherQualifications: null,
        selectedStudentForUpdate:null,
        regBDocUpdateModel: false,
        studentLoading:false,
        enrollments:[],
        student_enrollments:[]
        };

        //Initiating the ref object for each fields on the forms of both modals
        this.firsNameRef = React.createRef();
        this.lastNameRef = React.createRef();
        this.emailRef = React.createRef();
        this.phoneNumberRef = React.createRef();
        this.dobRef = React.createRef();
        this.dobWrapRef = React.createRef();
        this.genderIdRef = React.createRef();
        this.createdByRef = React.createRef();
        this.statusIdRef = React.createRef();
        this.statusIdRef = React.createRef();
        this.addressesRefs = [];
        this.handleValidityFocus = this.handleValidityFocus.bind(this);

        // Debounced version of handleSearch function
        this.debouncedHandleSearch = debounce(this.fetchAllStaff, 2000);

        this.createValidationsInstance();
        this.formInitialState = {
        first_name: "",
        last_name: "",
        nic: "",
        dob: "",
        email: "",
        phone_number: "",
        gender_id: "",
        status_id: "",
        created_on: "",
        created_by: "",
        postalcode: "",
        };
    }

    toggleStudentStatsModal = (student) => {
        this.setState((prevState) => {
        return {
            selectedStudentStat: student,
            studentStatsModal: !prevState.studentStatsModal,
        };
        });
    };

    
    toggleRegBDocUpdateModel = (student) => {
        this.setState((prevState) => {
        return {
            selectedStudentForUpdate: student,
            regBDocUpdateModel: !prevState.regBDocUpdateModel,
        };
        });
    };

    createValidationsInstance() {
        this.validator = new SimpleReactValidator({
        validators: {
            address: {
            message: "The :attribute must be a valid address",
            rule: (val, params, validator) => {
                return (
                validator.helpers.testRegex(val, /^[a-zA-Z-/:0-9,\s]+$/i) &&
                params.indexOf(val) === -1
                );
            },
            messageReplace: (message, params) =>
                message.replace(":values", this.helpers.toSentence(params)), // optional
            },
            dateBefore: {
            message: "The :attribute must be before current date",
            rule: (val, params, validator) => {
                const selectedDate = new Date(val);
                const currentDate = new Date();
                return selectedDate < currentDate;
            },
            messageReplace: (message, params) =>
                message.replace(":values", this.helpers.toSentence(params)), // optional
            required: true,
            },
            phone_number: {
            message: "The :attribute must be a valid phone number",
            rule: (val, params, validator) => {
                const isTenDigitsStartingWithZero =
                val.length === 10 && val.startsWith("0");
                const isNineDigits = val.length === 9 && !val.startsWith("0");
                return isTenDigitsStartingWithZero || isNineDigits;
            },
            messageReplace: (message, params) =>
                message.replace(":values", this.helpers.toSentence(params)), // optional
            required: true,
            },
        },
        });
        this.updateValidator = new SimpleReactValidator();
    }

    async getAllStudentAddressTypes() {
        this.setState({ isAddressesLoading: true });
        this.addressesRefs = [];
        let types;
        try {
        const res = await StudentAddressTypeService.getAllWithoutPagination();
        types = res.data;
        } catch (error) {
        types = [];
        }
        const addressValidity = [];
        types.forEach((type) => {
        addressValidity.push(false);
        this.addressesRefs.push({
            country_id: React.createRef(),
            province_id: React.createRef(),
            city_id: React.createRef(),
            address_1: React.createRef(),
            address_2: React.createRef(),
            postalcode: React.createRef(),
        });
        });

        const studentAddresses = this.state.studentAddresses;
        this.setState(
        (prevState) => ({
            studentAddressTypes: types,
            addressValidity: addressValidity,
            studentAddresses: types.map((type, index) => {
            let obj = {
                ...type,
                ...studentAddresses[index],
                visibility: true,
            };
            delete obj["display_order"];
            return obj;
            }),
        }),
        () => {
            const { studentAddresses } = this.state;

            const studentAddressVisibility = studentAddresses.map((item, index) => {
            if (index > 0) {
                item.visibility = false;
            }
            return item;
            });
            this.setState({ studentAddressesAdd: studentAddressVisibility });

            const studentAddressUpdateVisibility = studentAddresses.map(
            (item, index) => {
                if (index > 0) {
                if (
                    !item.country_id ||
                    item.country_id === null ||
                    item.country_id === undefined
                ) {
                    item.visibility = false;
                } else {
                    item.visibility = true;
                }
                }
                return item;
            }
            );
            this.setState({ studentAddresses: studentAddressUpdateVisibility });
        }
        );

        this.setState({ isAddressesLoading: false }); // Set isLoading to false after data is fetched
    }

    componentDidMount() {
        this.loadInitialData();
    }

    loadInitialData() {
        let privilege_edit = !!this.props.state.privilege_edit;
        let privilege_add = !!this.props.state.privilege_add;
        let privilege_delete = !!this.props.state.privilege_delete;
        this.setState(
        {
            addVisibility: privilege_add,
            editVisibility: privilege_edit,
            deleteVisibility: privilege_delete,
            user_list_table_id: sessionStorage.getItem("table_log_id"),
            session_staff_user_id: sessionStorage.getItem("manage_user_id"),
            main_table_id: this.props.state.main_table_id,
            breadcrumb2: this.props.state.breadcrumb2,
            nodeTitle: this.props.state.nodeTitle,
        },
        () => {
            this.fetchAllStaff();
        }
        );
    }

    getAllGenders() {
        GenderService.getAllGenders().then((res) => {
        this.setState({ genders: res.data });
        });
    }

    fetchAllStaff = () => {
        const {
        limit,
        offset,
        sortColumn,
        sortDirection,
        search_term,
        user_list_table_id,
        session_staff_user_id,
        } = this.state;
        const {
        mid,
        owner_restriction,
        lg_user_id,
        lg_user_table_id,
        user_list_restriction,
        } = this.props.state;
        let create_user_id =
        !!owner_restriction && lg_user_id ? lg_user_id : "null";
        let create_user_table_id =
        !!owner_restriction && lg_user_table_id ? lg_user_table_id : "null";
        let user_table_id =
        !!user_list_restriction && user_list_table_id
            ? user_list_table_id
            : "null";
        let staff_id =
        !!user_list_restriction && session_staff_user_id ? session_staff_user_id : "null";
        let node_id = mid;

        NonAcademicService.getAll(
        node_id,
        user_table_id,
        create_user_id,
        create_user_table_id,
        staff_id,
        limit,
        offset,
        sortColumn,
        sortDirection,
        search_term
        )
        .then((response) => {
            if (response.success) {
                this.setState(
                {
                    students: response?.data?.staff_members?.filter(
                    (std) => std.is_lg_user
                    ),
                },
                () => {
                    this.setState({ updateStudentItem: this.state.students[0] }, () => {
                    });
                }
                );
                this.setState({
                students: response.data.staff_members,
                totalStudents: response.data.total_count,
                });
            } else {
            sweetStatusAlert("Failed!", response.message, "error");
            }
        })
        .catch((error) => {
            sweetStatusAlert(
            "Failed!",
            "Error fetching staff members. Please refresh the screen!",
            "error"
            );
        })
        .finally(() => {
            this.setState({ isTableDataLoading: false });
        });
    };

    handlePageChange = (event, newPage) => {
        const { limit } = this.state;
        const newOffset = newPage * limit;
        this.setState(
        {
            offset: newOffset,
            isTableDataLoading: true,
            currentPage: newPage,
        },
        () => {
            this.fetchAllStaff();
        }
        );
    };

    handlePageOffsetChange = (newOffset, newPage) => {
        this.setState(
        {
            offset: newOffset,
            isTableDataLoading: true,
            currentPage: newPage,
        },
        () => {
            this.fetchAllStaff();
        }
        );
    };

    handleRowsPerPageChange = (event) => {
        const newLimit = parseInt(event.target.value, 10);
        const newPage = Math.floor(this.state.offset / newLimit);
        this.setState(
        {
            limit: newLimit,
            offset: newLimit * newPage,
            isTableDataLoading: true,
            currentPage: newPage,
        },
        () => {
            this.fetchAllStaff();
        }
        );
    };

    handleSearch = (event) => {
        const search_term = event.target.value.trim();
        const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

        if (search_term === "" || regex.test(search_term)) {
        this.setState(
            {
            search_term,
            isTableDataLoading: true,
            offset: 0,
            currentPage: 0,
            searchError: false,
            },
            () => {
            // Call the debounced version of fetchStudentData
            this.debouncedHandleSearch();
            }
        );
        } else {
        this.setState({ search_term, searchError: true });
        }
    };

    handleSortChange = (sortColumn) => {
        // If the same column is clicked, toggle the sort direction
        const { sortColumn: currentSortColumn, sortDirection } = this.state;
        const newSortDirection =
        currentSortColumn === sortColumn && sortDirection === "asc"
            ? "desc"
            : "asc";

        this.setState(
        {
            sortColumn,
            sortDirection: newSortDirection,
            offset: 0, // Reset offset when changing sorting
            currentPage: 0,
            isTableDataLoading: true,
        },
        () => {
            this.fetchAllStaff();
        }
        );
    };

    handleSweetAlert = (toggleFunction, modalVisibility) => {
        if (this.state.isModified) {
        sweetAlert().then((response) => {
            this.validator.purgeFields();
            this.validator.hideMessages();
            this.setState(this.formInitialState);
            this.setState(() => ({
            [modalVisibility]: response,
            isModified: false,
            }));
        });
        } else {
        this.validator.purgeFields();
        this.validator.hideMessages();
        this.setState(this.formInitialState);
        toggleFunction();
        }
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState(() => ({ [name]: value, isModified: true }));
    };

    getProvincesForCountry = async (country_id, is_initial = false) => {
        if (country_id && country_id !== "Select") {
        const response = await ProvinceService.getProvinceForCountry(country_id);
        if (response.success) {
            return response.data;
        } else {
            if (
            Object.keys(response.data).length === 0 &&
            response.success === false &&
            response.message === "Provinces/District not found" &&
            is_initial === true
            ) {
            return undefined;
            } else {
            sweetStatusAlert("Failed!", response.message, "error");
            }
        }
        } else {
        return null;
        }
    };

    getCitiesForProvince = async (province_id, is_initial = false) => {
        if (province_id && province_id !== "Select") {
        const response = await CityService.getCitiesForProvince(province_id);
        if (response.success) {
            return response.data;
        } else {
            if (
            Object.keys(response.data).length === 0 &&
            response.success === false &&
            response.message === "Cities not found" &&
            is_initial === true
            ) {
            return undefined;
            } else {
            sweetStatusAlert("Failed!", response.message, "error");
            }
        }
        } else {
        return null;
        }
    };

    handleUpdatedAddress = async (index, name, value) => {
        const { studentAddresses } = this.state;
        const updatedAddresses = [...studentAddresses];

        if (name === "country_id") {
        const country_id = value;
        if (updatedAddresses[index]) {
            updatedAddresses[index].provinces = [];
            updatedAddresses[index].cities = [];
            try {
            const provinces = await this.getProvincesForCountry(country_id, true);
            if (provinces) {
                updatedAddresses[index].provinces = provinces;
            } else {
                updatedAddresses[index].province_id = null;
                updatedAddresses[index].city_id = null;
            }
            } catch (error) {
            this.setApiErrorArray(country_id, index, "province");
            }
            this.setState({ studentAddresses: updatedAddresses });
        }
        }

        if (name === "province_id") {
        const province_id = value;
        if (updatedAddresses[index]) {
            updatedAddresses[index].cities = [];
            try {
            const cities = await this.getCitiesForProvince(province_id, true);
            if (cities) {
                updatedAddresses[index].cities = cities;
            } else {
                updatedAddresses[index].city_id = null;
            }
            } catch (error) {
            this.setApiErrorArray(province_id, index, "city");
            }
            this.setState({ studentAddresses: updatedAddresses });
        }
        }
    };

    handleStudentProfileRoute = (student) => {
        this.props.history.push({
        pathname: routes.student_profile,
        state: {
            ...this.props.state,
            student
        },
        });
    }

    // Re fetch the necessary data based on the error array of city and province
    reFetchErrorApi = async () => {
        let countryPromises, provincePromise;
        if (this.state.errorProvince.length > 0) {
        countryPromises = this.state.errorProvince.map(
            async ({ country_id, index }) => {
            return await this.handleUpdatedAddress(
                index,
                "country_id",
                country_id
            );
            }
        );
        }
        if (this.state.errorCity.length > 0) {
        provincePromise = this.state.errorCity.map(
            async ({ province_id, index }) => {
            return await this.handleUpdatedAddress(
                index,
                "province_id",
                province_id
            );
            }
        );
        }
        await Promise.all([countryPromises, provincePromise]);
    };

    getStudentAddressById = async (student_id) => {
        this.setState({
        isAddressesLoading: true,
        errorCity: [],
        errorProvince: [],
        });

        const addresses = await StudentAddressService.getStudentAddressById(
        student_id
        );
        this.setState({ studentAddresses: addresses.data });

        await this.getAllStudentAddressTypes();

        const promises =
        addresses.data &&
        addresses.data.length > 0 &&
        addresses.data.map(async (address, index) => {
            const countryPromise = await this.handleUpdatedAddress(
            index,
            "country_id",
            address.country_id
            );
            const provincePromise = await this.handleUpdatedAddress(
            index,
            "province_id",
            address.province_id
            );
            return await Promise.all([countryPromise, provincePromise]);
        });

        if (promises) {
        await Promise.all(promises);
        }

        this.reFetchErrorApi();

        this.setState({ isAddressesLoading: false });
    };

    //Setting the error array of city and province state based on the api calls made on the getAllStudentAddressById function
    setApiErrorArray = (id, index, type) => {
        if (type === "province") {
        if (
            !this.state.errorProvince.includes({ country_id: id, index: index })
        ) {
            this.setState((prev) => ({
            errorProvince: [
                ...prev.errorProvince,
                { country_id: id, index: index },
            ],
            }));
        }
        } else if (type === "city") {
        if (!this.state.errorCity.includes({ province_id: id, index: index })) {
            this.setState((prev) => ({
            errorCity: [...prev.errorCity, { province_id: id, index: index }],
            }));
        }
        }
    };

    //Handle Edit Submit
    handleEditSubmit = async (event) => {
        event.preventDefault();
        this.handleAddressFeildValidity();
        if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.handleValidityFocus("update");
        this.forceUpdate();
        } else {
        try {
            this.setState({ isLoading: true });
            const {
            stu_id,
            first_name,
            last_name,
            nic,
            email,
            phone_number,
            dob,
            gender_id,
            created_on,
            created_by,
            status_id,
            studentAddresses,
            node_mid,
            school,
            grade,
            main_table_id,
            user_code,
            is_lg_user,
            } = this.state;

            const studentItem = {
            first_name: first_name,
            last_name: last_name,
            nic: nic,
            email: email,
            phone_number: parseInt(phone_number),
            dob: dob === "" ? null : dob,
            gender_id: parseInt(gender_id),
            school: school,
            grade: grade,
            created_on: created_on === "" ? null : created_on,
            created_by: created_by,
            user_status_id: parseInt(status_id),
            node_mid: node_mid,
            user_code: user_code,
            };

            const studentId = stu_id;
            const studentResponse = await StudentService.update(
            JSON.stringify(studentItem),
            studentId
            );

            if (studentResponse.success) {
            if (!!is_lg_user) {
                this.props.setUserName(first_name, last_name);
            }
            const filteredAddressesWithStudentId = studentAddresses.map(
                (address) => {
                const {
                    name,
                    description,
                    cities,
                    provinces,
                    country_id,
                    province_id,
                    city_id,
                    visibility,
                    ...rest
                } = address; // Destructure the name and description fields from the address object
                return {
                    ...rest, // Spread the rest of the address fields
                    student_id: studentId, // Add the student_id field
                    country_id: parseInt(country_id), // Convert the country_id to an integer
                    province_id: country_id ? parseInt(province_id) : null,
                    city_id: province_id ? parseInt(city_id) : null,
                    status: "active",
                    student_address_type_id: address.student_address_type_id, // Add the student_address_type_id field
                };
                }
            );

            if (filteredAddressesWithStudentId.length > 0) {
                await StudentAddressService.update(
                JSON.stringify(filteredAddressesWithStudentId)
                );
            }

            this.setState({ isLoading: false, showModal: false });
            sweetStatusAlert(
                "Success!",
                "Student information updated successfully..!",
                "success"
            );

            this.fetchAllStaff();
            this.validator.purgeFields();
            this.validator.hideMessages();
            this.setState(this.formInitialState);

            const studentUserItem = { user_email: email };
            await UserManagementService.updateByStuId(
                JSON.stringify(studentUserItem),
                studentId,
                main_table_id
            );
            } else {
            this.setState({ isLoading: false });
            sweetStatusAlert("Failed!", studentResponse.message, "error");
            }
        } catch (e) {
            this.setState({ isLoading: false });
            sweetStatusAlert(
            "Failed!",
            "Failed to update the student info!",
            "error"
            );
        }
        }
    };

    toggleAddStudentModal = () => {
        this.setState(
        (prevState) => ({
            showInsertModal: !prevState.showInsertModal,
            first_name: "",
            last_name: "",
            dob: "",
            email: "",
            phone_number: "",
            gender_id: "",
            status_id: "",
            created_on: "",
            created_by: "",
            studentAddresses: [],
            grade: null,
            school: "",
        }),
        
        );
    };

    handleValidityFocus = (submission_type) => {
        if (!this.validator.fieldValid("first_name")) {
        this.firsNameRef.current.focus();
        return;
        } else if (!this.validator.fieldValid("last_name")) {
        this.lastNameRef.current.focus();
        return;
        } else if (!this.validator.fieldValid("email")) {
        this.emailRef.current.focus();
        return;
        } else if (!this.validator.fieldValid("phone_number")) {
        this.phoneNumberRef.current.focus();
        return;
        } else if (!this.validator.fieldValid("dob")) {
        this.dobRef.current.setFocus();
        this.dobWrapRef.current.scrollIntoView();
        return;
        } else if (!this.validator.fieldValid("gender_id")) {
        this.genderIdRef.current.focus();
        return;
        } else if (!this.validator.fieldValid("created_by")) {
        this.createdByRef.current.focus();
        return;
        } else if (!this.validator.fieldValid("status_id")) {
        this.statusIdRef.current.focus();
        return;
        }

        for (const [index, address] of this.addressesRefs.entries()) {
        if (
            !this.validator.fieldValid(`${submission_type}_country_id${index}`) &&
            this.state.addressValidity[index]
        ) {
            address.country_id.current.focus();
            break;
        } else if (
            !this.validator.fieldValid(`${submission_type}_province_id${index}`) &&
            this.state.addressValidity[index]
        ) {
            address.province_id.current.focus();
            break;
        } else if (
            !this.validator.fieldValid(`${submission_type}_city_id${index}`) &&
            this.state.addressValidity[index]
        ) {
            address.city_id.current.focus();
            break;
        } else if (
            !this.validator.fieldValid(`${submission_type}_address_1${index}`) &&
            this.state.addressValidity[index]
        ) {
            address.address_1.current.focus();
            break;
        } else if (
            !this.validator.fieldValid(`${submission_type}_address_2${index}`) &&
            this.state.addressValidity[index]
        ) {
            address.address_2.current.focus();
            break;
        } else if (
            !this.validator.fieldValid(`${submission_type}_postalcode${index}`) &&
            this.state.addressValidity[index]
        ) {
            address.postalcode.current.focus();
            break;
        }
        }
    };

    handleAddressFeildValidity = () => {
        this.state.studentAddresses.forEach((address, index) => {
        if (
            address.country_id ||
            address.province_id ||
            address.city_id ||
            address.address_1 ||
            address.address_2 ||
            address.postalcode
        ) {
            this.setState((prev) => {
            const updatedAddressValidity = [...prev.addressValidity];
            updatedAddressValidity[index] = true;
            return {
                addressValidity: updatedAddressValidity,
            };
            });
        } else {
            this.setState((prev) => {
            const updatedAddressValidity = [...prev.addressValidity];
            updatedAddressValidity[index] = false;
            return {
                addressValidity: updatedAddressValidity,
            };
            });
        }
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        this.handleAddressFeildValidity();
        if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.handleValidityFocus("add");
        this.forceUpdate();
        } else {
        this.setState({ isLoading: true });
        try {
            const {
            first_name,
            last_name,
            email,
            phone_number,
            dob,
            grade,
            school,
            gender_id,
            created_on,
            created_by,
            status_id,
            studentAddresses,
            search_term,
            session_staff_user_id,
            user_list_table_id,
            main_table_id,
            user_code,
            } = this.state;

            const newStudent = {
            first_name: first_name,
            last_name: last_name,
            email: email,
            phone_number: parseInt(phone_number),
            dob: dob,
            gender_id: parseInt(gender_id),
            created_on: created_on === "" ? null : created_on,
            created_by: created_by,
            user_status_id: parseInt(status_id),
            node_mid: !!this.props.state.mid ? this.props.state.mid : null,
            create_user_id: session_staff_user_id,
            create_user_table_id: user_list_table_id,
            user_table_id: main_table_id,
            grade: grade,
            school: school,
            user_code: user_code,
            };
            const studentResponse = await StudentService.create(
            JSON.stringify(newStudent)
            );
            if (studentResponse.success) {
            const studentId = studentResponse.data.stu_id;
            const studentEmail = studentResponse.data.email;
            const filteredAddressesWithStudentId = studentAddresses.map(
                (address) => {
                const {
                    name,
                    description,
                    cities,
                    provinces,
                    country_id,
                    province_id,
                    city_id,
                    visibility,
                    ...rest
                } = address; // Destructure the name and description fields from the address object
                return {
                    ...rest, // Spread the rest of the address fields
                    student_id: studentId, // Add the student_id field
                    country_id: parseInt(country_id), // Convert the country_id to an integer
                    province_id: parseInt(province_id),
                    city_id: parseInt(city_id),
                    status: "active",
                };
                }
            );

            if (filteredAddressesWithStudentId.length > 0) {
                await StudentAddressService.create(
                JSON.stringify(filteredAddressesWithStudentId)
                );
            }
            this.setState({ isLoading: false, showInsertModal: false });
            sweetStatusAlert(
                "Success!",
                "New staff member added successfully!",
                "success"
            );
            this.validator.purgeFields();
            this.validator.hideMessages();
            this.setState(this.formInitialState);

            const {
                mid,
                owner_restriction,
                lg_user_id,
                lg_user_table_id,
                user_list_restriction,
                session_staff_user_id,
                user_list_table_id,
            } = this.props.state;
            let create_user_id =
                !!owner_restriction && lg_user_id ? lg_user_id : "null";
            let create_user_table_id =
                !!owner_restriction && lg_user_table_id ? lg_user_table_id : "null";
            let user_table_id =
                !!user_list_restriction && user_list_table_id
                ? user_list_table_id
                : "null";
            let stu_id =
                !!user_list_restriction && session_staff_user_id ? session_staff_user_id : "null";

            // Fetch the newly added student separately and append it to the current students list
            await StudentService.getAllStuRegWithPaginationAndSorting(
                stu_id,
                user_table_id,
                create_user_id,
                create_user_table_id,
                mid,
                10,
                0,
                "stu_id",
                "desc",
                search_term
            )
                .then((response) => {
                if (response.success) {
                    const updatedStudents = [
                    response.data.students[0],
                    ...this.state.students,
                    ];
                    this.setState({ students: updatedStudents });
                }
                })
                .catch((error) => {
                sweetStatusAlert(
                    "Failed!",
                    "Error occured while fetching the students!",
                    "error"
                );
                });
            } else {
            this.setState({ isLoading: false });
            sweetStatusAlert("Failed!", studentResponse.message, "error");
            }
        } catch (e) {
            this.setState({ isLoading: false });
            sweetStatusAlert("Failed!", "Failed to create new student", "error");
        }
        }
    };

    getRespectiveStatusTypeID(name) {
        const type = this.state.statusTypes.find((item) => item.name === name);
        return type ? type.type_id : "";
    }

    clearAddress = (index) => {
        const { studentAddresses } = this.state;
        const keysToClear = [
        "country_id",
        "province_id",
        "city_id",
        "address_1",
        "address_2",
        "postalcode",
        ];

        if (index >= 0 && index < studentAddresses.length) {
        // Clear the values in the specified keys for the object at indexToClear
        keysToClear.forEach((key) => {
            studentAddresses[index][key] = null; // You can set it to null or any other desired value
        });
        this.setState({ studentAddresses: studentAddresses });
        }
    };

    toggleAddress = (id) => {
        const { studentAddressesAdd } = this.state;
        this.setState({ hidden: true });
        const updateStuAddress = studentAddressesAdd.map((item, index) => {
        if (index === id) {
            if (item.visibility) {
            sweetConfirmAlert().then(() => {
                item.visibility = !item.visibility;
                this.clearAddress(id);
                this.setState({ hidden: false });
            });
            } else {
            item.visibility = !item.visibility;
            }
        }
        if (!item.visibility) {
            this.setState({ hidden: false });
        }
        return item;
        });
        this.setState({ studentAddressesAdd: updateStuAddress });
    };

    toggleUpdateAddress = (id) => {
        const { studentAddresses } = this.state;
        this.setState({ hidden: true });
        const updateStuAddress = studentAddresses.map((item, index) => {
        if (index === id) {
            if (item.visibility) {
            sweetConfirmAlert().then(() => {
                item.visibility = !item.visibility;
                this.clearAddress(id);
                this.setState({ hidden: false });
            });
            } else {
            item.visibility = !item.visibility;
            }
        }
        if (!item.visibility) {
            this.setState({ hidden: false });
        }
        return item;
        });
        this.setState({ studentAddresses: updateStuAddress });
    };

    toggleAddStaffMemberSeparateModal = () => {
        this.setState(
        (prevState) => ({
            isAddStaffModalOpen: !prevState.isAddStaffModalOpen,
        }),
        async () => {
            if (!this.state.isAddStaffModalOpen) {
            this.fetchAllStaff();
            }
        }
        );
    };

    extractQualifications = (qualifications, type) => {
        return qualifications
        .filter((qualification) => qualification.type === type)
        .map((qualification, index) => {
            if (type === "other") {
            return {
                id: qualification.id,
                qualification: qualification.qualification,
                institution: qualification.institution,
                academic_year: qualification.academic_year,
                other_details: qualification.other_details,
                other_qualification: qualification.other_qualification,
            };
            } else {
            return {
                id: qualification.id,
                subject: `subject${index + 1}`,
                grade: `grade${index + 1}`,
                subjectValue: qualification.subject,
                gradeValue: qualification.grade,
            };
            }
        });
    };

    toggleUpdateStaffModal = (studentItem) => {
        if (studentItem) {
        this.setState({ updateStudentItem: studentItem }, () => {
            if (this.state.updateStudentItem) {
            this.setState({ isUpdateStaffModalOpen: true });
            }
        });
        } else {
        this.setState({ isUpdateStaffModalOpen: false });
        this.fetchAllStaff();
        }
    };

    createArrayWithEqualIdGroups = (arr) => {
        const idGroupMap = {};
        // Group objects by id
        arr.forEach((obj) => {
        const id = obj.chart_id;
        idGroupMap[id] = idGroupMap[id] || [];
        idGroupMap[id].push(obj);
        });
        const result = Object.values(idGroupMap).filter(
        (group) => group.length > 1
        );
        return result;
    };
    render() {
        const {
        isLoading,
        limit,
        students,
        totalStudents,
        isTableDataLoading,
        currentPage,
        editVisibility,
        addVisibility,
        nodeTitle,
        studentStatsModal,
        } = this.state;
        let breadcrumb2 =
        this.state.breadcrumb2 || nodeTitle
            ? `${this.state.breadcrumb2 && this.state.breadcrumb2}${
                nodeTitle && nodeTitle
            }`
            : undefined;
        let fromProfile = false;
        this.validator.purgeFields();
        let toggleUpdateClassName = `btn btn-icon btn-action btn-sm m-1 edit-assement-btn ${
        !!editVisibility ? "flaticon-edit-icon" : "flaticon-eye-icon"
        }`;
        const formattedBreadcrumb = breadcrumb2
        ? breadcrumb2.replaceAll(">", " > ")
        : "";
        return (
        <div style={{ height: "90vh", overflow: "auto" }}>
            <ContentWrapper>
            <StudentsStatModel
                studentStatsModal={studentStatsModal}
                toggleStudentStatsModal={this.toggleStudentStatsModal}
                closeBtnStyle={closeBtnStyle}
                selectedStudent={this.state.selectedStudentStat}
                createArrayWithEqualIdGroups={this.createArrayWithEqualIdGroups}
            />
            <RegBStaffDocUpdateModal
                visibility={{ add: this.state.addVisibility, edit: this.state.editVisibility, delete: this.state.deleteVisibility }}
                regBDocUpdateModel={this.state.regBDocUpdateModel}
                toggleRegBDocUpdateModel={this.toggleRegBDocUpdateModel}
                closeBtnStyle={closeBtnStyle}
                selectedStudent={this.state.selectedStudentForUpdate}
                state = {this.props.state}
                fetchAllStudents = {this.fetchAllStaff}
            />
            <Card>
                <CardHeader>
                <div>
                    {this.props.state.path !== "node" && (
                    <p
                        className="pb-4"
                        style={{ fontSize: "10.5625px", color: "#00000099" }}
                    >
                        {formattedBreadcrumb
                        ? `${formattedBreadcrumb && formattedBreadcrumb}`
                        : ""}
                    </p>
                    )}
                    {!fromProfile && (
                    <Form.Group
                        controlId="exampleForm.ControlInput1"
                        className="mb-2"
                    >
                        <Form.Control
                        type="text"
                        placeholder="Search"
                        onChange={this.handleSearch}
                        isInvalid={this.state.searchError}
                        style={{ width: "300px" }}
                        className="search-bar"
                        />
                        {this.state.searchError && (
                        <Form.Control.Feedback type="invalid">
                            Invalid input
                        </Form.Control.Feedback>
                        )}
                    </Form.Group>
                    )}
                </div>
                <div>
                    {addVisibility && !fromProfile && (
                    <Button
                        className="insert-btn"
                        variant="primary"
                        onClick={this.toggleAddStaffMemberSeparateModal}
                    >
                        Add Staff member 
                    </Button>
                    )}
                </div>
                </CardHeader>
                <CardBody>
                {isLoading && (
                    <PageSpinner id="show" text="Loading, Please wait!" />
                )}
                {isTableDataLoading ? (
                    <div className="loading-container">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                    </div>
                ) : (
                    <div>
                    <Table>
                        <TableHead>
                        <TableRow>
                            <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("user_code")}
                            >
                            User Code{" "}
                            {this.state.sortColumn === "user_code" && (
                                <span>
                                {this.state.sortDirection === "asc" ? (
                                    <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                ) : (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                )}
                                </span>
                            )}
                            </TableCell>
                            <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("first_name")}
                            >
                            First Name{" "}
                            {this.state.sortColumn === "first_name" && (
                                <span>
                                {this.state.sortDirection === "asc" ? (
                                    <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                ) : (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                )}
                                </span>
                            )}
                            </TableCell>
                            <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("last_name")}
                            >
                            Last Name{" "}
                            {this.state.sortColumn === "last_name" && (
                                <span>
                                {this.state.sortDirection === "asc" ? (
                                    <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                ) : (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                )}
                                </span>
                            )}
                            </TableCell>
                            <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("email")}
                            >
                            Email{" "}
                            {this.state.sortColumn === "email" && (
                                <span>
                                {this.state.sortDirection === "asc" ? (
                                    <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                ) : (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                )}
                                </span>
                            )}
                            </TableCell>
                            <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("nic")}
                            >
                            NIC{" "}
                            {this.state.sortColumn === "nic" && (
                                <span>
                                {this.state.sortDirection === "asc" ? (
                                    <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                ) : (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                )}
                                </span>
                            )}
                            </TableCell>
                            <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("designation")}
                            >
                            Designation{" "}
                            {this.state.sortColumn === "designation" && (
                                <span>
                                {this.state.sortDirection === "asc" ? (
                                    <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                ) : (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                )}
                                </span>
                            )}
                            </TableCell>
                            <TableCell
                            className="thead"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.handleSortChange("mobile")}
                            >
                            Contact No:{" "}
                            {this.state.sortColumn === "mobile" && (
                                <span>
                                {this.state.sortDirection === "asc" ? (
                                    <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                ) : (
                                    <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                                )}
                                </span>
                            )}
                            </TableCell>
                            <TableCell
                                className="thead"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                this.handleSortChange("note")
                                }
                            >
                                Note{" "}
                                {this.state.sortColumn === "note" && (
                                <span>
                                    {this.state.sortDirection === "asc"
                                    ? <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                                    : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}
                                </span>
                                )}
                            </TableCell>
                            <TableCell className="thead">Status</TableCell>
                            <TableCell className="thead">Actions</TableCell>
                            <TableCell className="thead">Documents</TableCell>
                        </TableRow>
                        </TableHead>

                        <TableBody>
                        {!!students.length &&
                            students.map((studentItem) => (
                            
                            <TableRow key={studentItem.stu_id}>
                                <TableCell className="tData">
                                {studentItem.user_code}
                                </TableCell>
                                <TableCell className="tData">
                                {studentItem.first_name}
                                </TableCell>
                                <TableCell className="tData">
                                {studentItem.last_name}
                                </TableCell>
                                <TableCell className="tData">
                                {studentItem.email}
                                </TableCell>
                                <TableCell className="tData">
                                {studentItem.nic}
                                </TableCell>
                                <TableCell className="tData">
                                {studentItem.designation}
                                </TableCell>
                                <TableCell className="tData">
                                {studentItem.mobile}
                                </TableCell>
                                <TableCell className="tData">
                                {studentItem.note}
                                </TableCell>
                                {studentItem.status || studentItem.status === 0 ? (
                                <TableCell className="tData">
                                    <span
                                    className={`label label-lg ${
                                        studentItem.status === 1
                                        ? "label-light-success"
                                        : "label-light-danger"
                                    } label-inline`}
                                    >
                                    {studentItem.user_status_id === 1
                                        ? "Active"
                                        : "Inactive"}
                                    </span>
                                </TableCell>
                                ) : (
                                <TableCell className="tData"></TableCell>
                                )}
                                <TableCell>
                                <div className="btn-group">
                                    <Button
                                    onClick={() =>
                                        this.toggleUpdateStaffModal(
                                        studentItem
                                        )
                                    }
                                    className={toggleUpdateClassName}
                                    title="Edit Details"
                                    />
                                </div>
                                </TableCell>
                                <TableCell>
                                <div className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn">
                                    <button
                                    style={{
                                        border: "none",
                                        backgroundColor: "transparent",
                                    }}
                                    onClick={() =>
                                        this.toggleRegBDocUpdateModel(studentItem)
                                    }
                                    >
                                    <SummarizeIcon
                                        sx={{
                                        fontSize: 20,
                                        backgroundColor: "transparent",
                                        color: "#a2a5b5",
                                        }}
                                        style={{ cursor: "pointer" }}
                                    />
                                    </button>
                                </div>
                                </TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {!fromProfile && (
                        <MaterialCustomTablePagination
                        totalCount={parseInt(totalStudents)}
                        currentPage={currentPage}
                        limit={limit}
                        handlePageChange={this.handlePageChange}
                        handleRowsPerPageChange={this.handleRowsPerPageChange}
                        handlePageOffsetChange={this.handlePageOffsetChange}
                        rowsPerPageOptions={[5, 10, 20]}
                        offset={this.state.offset}
                        />
                    )}
                    </div>
                )}
                </CardBody>
            </Card>
            </ContentWrapper>

            {this.state.isAddStaffModalOpen && (
            <RegBAddStaffModal
                isAdmin={sessionStorage.getItem("userType") === "admin"}
                isStudent={sessionStorage.getItem("userType") === "student"}
                state={this.props.state}
                isAddStaffModalOpen={this.state.isAddStaffModalOpen}
                toggleAddStudentModal={this.toggleAddStaffMemberSeparateModal}
                enrollments={this.state.student_enrollments} 
                studentEnrollmentsLoading={this.state.studentLoading} 
            />
            )}

            {this.state.isUpdateStaffModalOpen && (
            <RegBUpdateStaffModal
                isAdmin={sessionStorage.getItem("userType") === "admin"}
                isStudent={sessionStorage.getItem("userType") === "cgc_student"}
                state={this.props.state}
                isAddStudentModalOpen={this.state.isUpdateStaffModalOpen}
                toggleAddStudentModal={this.toggleUpdateStaffModal}
                updateStudentItem={this.state.updateStudentItem}
                olQualifications={this.state.olQualifications}
                alQualifications={this.state.alQualifications}
                otherQualifications={this.state.otherQualifications}
                enrollments={this.state.student_enrollments} 
                studentEnrollmentsLoading={this.state.studentLoading}
            />
            )}
        </div>
        );
    }
    }
